import React from 'react';
import { useInternalChat } from '../../context/InternalChatContext';
import TeamChatPanel from './TeamChatPanel';
import './TeamChat.css';

export default function TeamChatWidget() {
    const ctx = useInternalChat();

    // Context is null for non-internal users (provider returns children directly)
    if (!ctx) return null;

    const { panelOpen, unreadCount, directedToMe, openPanel, closePanel } = ctx;
    const hasDirected = directedToMe?.size > 0;

    return (
        <div className="tc-widget">
            {panelOpen && (
                <div className="tc-panel">
                    <TeamChatPanel onClose={closePanel} />
                </div>
            )}

            <button
                className="tc-trigger"
                onClick={panelOpen ? closePanel : openPanel}
                aria-label="Team chat"
            >
                {/* Users/team icon */}
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" strokeLinecap="round" fill="none"/>
                    <circle cx="9" cy="7" r="4" stroke="#fff" strokeWidth="2" fill="none"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="#fff" strokeWidth="2" strokeLinecap="round" fill="none"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#fff" strokeWidth="2" strokeLinecap="round" fill="none"/>
                </svg>

                {unreadCount > 0 && (
                    <span className="tc-badge" style={hasDirected ? { background: '#f57c00' } : {}}>
                        {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                )}
            </button>
        </div>
    );
}
